import { render } from "./SecondaryApplicants.vue?vue&type=template&id=7ec9c97c"
import script from "./SecondaryApplicants.vue?vue&type=script&lang=js"
export * from "./SecondaryApplicants.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__